import { Link } from "react-router-dom";
import { useContext } from "react";
import logo from '../images/logo.png';
import UserContext from "../Components/UserContext";

const NotFound = () => {
  const { session } = useContext(UserContext);

  const getHomeLink = () => {
    if (!session) return "/";
    if (session.role === 'admin' || session.role === 'super_admin') return "/admin/dashboard";
    if (session.isTrainer && session.trainerStatus === 'active') return "/trainer/home";
    return "/student/home";
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-l from-dark-100 to-primary py-6 shadow-[0_-4px_12px_rgba(0,0,0,0.2)] px-4">
      
      {/* Logo */}
      <img
        src={logo}
        alt="Yogvital"
        className="h-32 w-32 rounded-full mb-6 border-4 border-accent dark:border-white shadow-lg"
      />

      {/* Heading */}
      <h1 className="text-6xl font-extrabold tracking-wide text-accent dark:text-white mb-2">
        404
      </h1>
      <p className="text-xl md:text-2xl font-medium text-gray-600 dark:text-gray-300 mb-6">
        Sorry, the page you’re looking for doesn’t exist.
      </p>

      {/* Home Button */}
      <Link
        to={getHomeLink()}
        className="bg-gradient-to-r from-primary to-accent  hover:from-primary-900 hover:to-accent-900  text-white font-semibold px-6 py-2 rounded-2xl transition duration-300 shadow-md"
      >
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
